import HaulTypes from "./HaulTypes";

export default HaulTypes;